module.exports = __webpack_public_path__ + "static/media/blackEnabledTicketIcon.8dffba5c.svg";